export var LocationType;
(function (LocationType) {
    /** Unknown location type. */
    LocationType["UNKNOWN_LOCATION"] = "UNKNOWN_LOCATION";
    /** Event is on-site at a specific physical location. */
    LocationType["VENUE"] = "VENUE";
    /** Event is online, such as a virtual video conference. */
    LocationType["ONLINE"] = "ONLINE";
})(LocationType || (LocationType = {}));
export var SubdivisionSubdivisionType;
(function (SubdivisionSubdivisionType) {
    SubdivisionSubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    /** State */
    SubdivisionSubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    /** County */
    SubdivisionSubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    /** City/town */
    SubdivisionSubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    /** Neighborhood/quarter */
    SubdivisionSubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    /** Street/block */
    SubdivisionSubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
    SubdivisionSubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionSubdivisionType || (SubdivisionSubdivisionType = {}));
export var RecurrenceStatusStatus;
(function (RecurrenceStatusStatus) {
    /** Unknown recurrance status. */
    RecurrenceStatusStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** Event happens only once and can last multiple days. */
    RecurrenceStatusStatus["ONE_TIME"] = "ONE_TIME";
    /** A series of events that repeat. */
    RecurrenceStatusStatus["RECURRING"] = "RECURRING";
    /** Next event in a schedule of recurring events. */
    RecurrenceStatusStatus["RECURRING_UPCOMING"] = "RECURRING_UPCOMING";
    /** Latest event that ended in a schedule of recurring events. */
    RecurrenceStatusStatus["RECURRING_RECENTLY_ENDED"] = "RECURRING_RECENTLY_ENDED";
    /** Latest canceled event in a schedule of recurring events */
    RecurrenceStatusStatus["RECURRING_RECENTLY_CANCELED"] = "RECURRING_RECENTLY_CANCELED";
})(RecurrenceStatusStatus || (RecurrenceStatusStatus = {}));
export var Status;
(function (Status) {
    /** Unknown event status. */
    Status["UNKNOWN_EVENT_STATUS"] = "UNKNOWN_EVENT_STATUS";
    /** Event is published and scheduled to start. */
    Status["UPCOMING"] = "UPCOMING";
    /** Event has started. */
    Status["STARTED"] = "STARTED";
    /** Event has ended. */
    Status["ENDED"] = "ENDED";
    /** Event is canceled. */
    Status["CANCELED"] = "CANCELED";
    /** Event is not public. */
    Status["DRAFT"] = "DRAFT";
})(Status || (Status = {}));
export var RegistrationTypeType;
(function (RegistrationTypeType) {
    /** Unknown registration type. */
    RegistrationTypeType["UNKNOWN_REGISTRATION_TYPE"] = "UNKNOWN_REGISTRATION_TYPE";
    /** Guests register by RSVPing to the event. */
    RegistrationTypeType["RSVP"] = "RSVP";
    /** Guests register by buying tickets. */
    RegistrationTypeType["TICKETING"] = "TICKETING";
    /** Guests register externally using some other site or platform. */
    RegistrationTypeType["EXTERNAL"] = "EXTERNAL";
    /** No registration is required, all guests can attend. This registration type is for only displaying the event details on a site. The property value can be changed from RSVP/TICKETING to EXTERNAL or NONE after the event is created, depending on any additional configurations applied to the event. */
    RegistrationTypeType["NONE"] = "NONE";
})(RegistrationTypeType || (RegistrationTypeType = {}));
export var RegistrationStatusStatus;
(function (RegistrationStatusStatus) {
    /** Registration status is not applicable */
    RegistrationStatusStatus["UNKNOWN_REGISTRATION_STATUS"] = "UNKNOWN_REGISTRATION_STATUS";
    /** Registration is closed after tickets are sold out. */
    RegistrationStatusStatus["CLOSED_AUTOMATICALLY"] = "CLOSED_AUTOMATICALLY";
    /** Registration is closed when the `registration.registrationDisabled` property is set to `true`. */
    RegistrationStatusStatus["CLOSED_MANUALLY"] = "CLOSED_MANUALLY";
    /** Guests can start RSVPing to the event. */
    RegistrationStatusStatus["OPEN_RSVP"] = "OPEN_RSVP";
    /** Guest list has reached the maximum, new guests are added to a waitlist. */
    RegistrationStatusStatus["OPEN_RSVP_WAITLIST_ONLY"] = "OPEN_RSVP_WAITLIST_ONLY";
    /** Guests can buy tickets to the event. */
    RegistrationStatusStatus["OPEN_TICKETS"] = "OPEN_TICKETS";
    /** Guests register on a different page or web address. */
    RegistrationStatusStatus["OPEN_EXTERNAL"] = "OPEN_EXTERNAL";
    /** Registration via RSVP is scheduled for the future. */
    RegistrationStatusStatus["SCHEDULED_RSVP"] = "SCHEDULED_RSVP";
})(RegistrationStatusStatus || (RegistrationStatusStatus = {}));
export var ResponseType;
(function (ResponseType) {
    /** Unknown response type. */
    ResponseType["UNKNOWN_RESPONSE_TYPE"] = "UNKNOWN_RESPONSE_TYPE";
    /** Only a **Yes** answer is available to select when RSVP'ing to an event. */
    ResponseType["YES_ONLY"] = "YES_ONLY";
    /** *Yes** and **No** answers are available to select when RSVP'ing to an event. */
    ResponseType["YES_AND_NO"] = "YES_AND_NO";
})(ResponseType || (ResponseType = {}));
/** Tax application settings. */
export var TaxType;
(function (TaxType) {
    /** Unknown tax type. */
    TaxType["UNKNOWN_TAX_TYPE"] = "UNKNOWN_TAX_TYPE";
    /** Deduct the fee from the ticket price for a seller. For example, if you're selling tickets for $10, a service fee of $0.25 is deducted from the price and you'll get $9.75. */
    TaxType["INCLUDED_IN_PRICE"] = "INCLUDED_IN_PRICE";
    /** Show the fee in addition to the ticket price at checkout and a guest pays the fee. For example, if you sell tickets for $10, a customer sees a service fee of $0.25 and pays $10.25 in total. */
    TaxType["ADDED_AT_CHECKOUT"] = "ADDED_AT_CHECKOUT";
})(TaxType || (TaxType = {}));
export var GuestTypeType;
(function (GuestTypeType) {
    /** Unknown guest type. */
    GuestTypeType["UNKNOWN_GUEST_TYPE"] = "UNKNOWN_GUEST_TYPE";
    /** All site visitors can RSVP to the event. */
    GuestTypeType["VISITOR_OR_MEMBER"] = "VISITOR_OR_MEMBER";
    /** Only people who have signed up as members of your site are able to RSVP to the event. */
    GuestTypeType["MEMBER"] = "MEMBER";
})(GuestTypeType || (GuestTypeType = {}));
export var InitialRegistrationTypeType;
(function (InitialRegistrationTypeType) {
    /** Unknown initial registration type. */
    InitialRegistrationTypeType["UNKNOWN_INITIAL_REGISTRATION_TYPE"] = "UNKNOWN_INITIAL_REGISTRATION_TYPE";
    /** Guests register by RSVPing to the event. */
    InitialRegistrationTypeType["RSVP"] = "RSVP";
    /** Guests register by buying tickets. This property value never changes. */
    InitialRegistrationTypeType["TICKETING"] = "TICKETING";
})(InitialRegistrationTypeType || (InitialRegistrationTypeType = {}));
export var InputControlType;
(function (InputControlType) {
    /** Single text value field. */
    InputControlType["INPUT"] = "INPUT";
    /** Single text value field. */
    InputControlType["TEXTAREA"] = "TEXTAREA";
    /** Single-choice field of predefined values. */
    InputControlType["DROPDOWN"] = "DROPDOWN";
    /** Single-choice field of predefined values. */
    InputControlType["RADIO"] = "RADIO";
    /** Multiple-choice field of predefined values. */
    InputControlType["CHECKBOX"] = "CHECKBOX";
    /** First and last name fields. */
    InputControlType["NAME"] = "NAME";
    /** Additional guests and respective guest names fields. */
    InputControlType["GUEST_CONTROL"] = "GUEST_CONTROL";
    /** Single-line address field. */
    InputControlType["ADDRESS_SHORT"] = "ADDRESS_SHORT";
    /** Full address field. */
    InputControlType["ADDRESS_FULL"] = "ADDRESS_FULL";
    /** Year, month and day fields. */
    InputControlType["DATE"] = "DATE";
})(InputControlType || (InputControlType = {}));
export var ValueType;
(function (ValueType) {
    ValueType["TEXT"] = "TEXT";
    ValueType["NUMBER"] = "NUMBER";
    ValueType["TEXT_ARRAY"] = "TEXT_ARRAY";
    ValueType["DATE_TIME"] = "DATE_TIME";
    ValueType["ADDRESS"] = "ADDRESS";
})(ValueType || (ValueType = {}));
export var ConferenceTypeType;
(function (ConferenceTypeType) {
    /** Default value. This value is unused */
    ConferenceTypeType["UNKNOWN_CONFERENCE_TYPE"] = "UNKNOWN_CONFERENCE_TYPE";
    /** Guests can do some actions during the conference, for example talk, turn on their camera and show their screen. */
    ConferenceTypeType["MEETING"] = "MEETING";
    /** Guests can only watch the conference. */
    ConferenceTypeType["WEBINAR"] = "WEBINAR";
})(ConferenceTypeType || (ConferenceTypeType = {}));
export var Type;
(function (Type) {
    /** Created manually by the user. */
    Type["MANUAL"] = "MANUAL";
    /** Created automatically when publishing recurring events. */
    Type["RECURRING_EVENT"] = "RECURRING_EVENT";
    /** Created automatically and used to store component events. */
    Type["COMPONENT"] = "COMPONENT";
})(Type || (Type = {}));
export var RequestedFields;
(function (RequestedFields) {
    /** Unknown requested field. */
    RequestedFields["UNKNOWN_REQUESTED_FIELD"] = "UNKNOWN_REQUESTED_FIELD";
    /** Returns `shortDescription`, `mainImage` and `calendarUrls`. */
    RequestedFields["DETAILS"] = "DETAILS";
    /** Returns `detailedDescription`. */
    RequestedFields["TEXTS"] = "TEXTS";
    /** Returns `registration`. */
    RequestedFields["REGISTRATION"] = "REGISTRATION";
    /** Returns `eventPageUrl`. */
    RequestedFields["URLS"] = "URLS";
    /** Returns `form`. */
    RequestedFields["FORM"] = "FORM";
    /** Returns `summaries`. */
    RequestedFields["DASHBOARD"] = "DASHBOARD";
    /** Returns `feed`. */
    RequestedFields["FEED"] = "FEED";
    /** Returns `onlineConferencing.session`. */
    RequestedFields["ONLINE_CONFERENCING_SESSION"] = "ONLINE_CONFERENCING_SESSION";
    /** Returns `seoSettings`. */
    RequestedFields["SEO_SETTINGS"] = "SEO_SETTINGS";
    /** Returns `agendaSettings`. */
    RequestedFields["AGENDA"] = "AGENDA";
    /** Returns `categories`. */
    RequestedFields["CATEGORIES"] = "CATEGORIES";
    RequestedFields["CUSTOMIZABLE_TICKETS"] = "CUSTOMIZABLE_TICKETS";
})(RequestedFields || (RequestedFields = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var CommonSortOrder;
(function (CommonSortOrder) {
    CommonSortOrder["ASC"] = "ASC";
    CommonSortOrder["DESC"] = "DESC";
})(CommonSortOrder || (CommonSortOrder = {}));
export var Relation;
(function (Relation) {
    /** User is attending the event. The user RSVP'd with status of `YES` or has ordered tickets. */
    Relation["ATTENDING"] = "ATTENDING";
})(Relation || (Relation = {}));
export var LocationLocationType;
(function (LocationLocationType) {
    LocationLocationType["VENUE"] = "VENUE";
    LocationLocationType["ONLINE"] = "ONLINE";
})(LocationLocationType || (LocationLocationType = {}));
export var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    /** State */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    /** County */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    /** City/town */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    /** Neighborhood/quarter */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    /** Street/block */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
    SubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionType || (SubdivisionType = {}));
export var EventsRecurrenceStatusStatus;
(function (EventsRecurrenceStatusStatus) {
    /** Event occurs only once. */
    EventsRecurrenceStatusStatus["ONE_TIME"] = "ONE_TIME";
    /** Event is recurring. */
    EventsRecurrenceStatusStatus["RECURRING"] = "RECURRING";
    /** Marks the next upcoming occurrence of the recurring event. */
    EventsRecurrenceStatusStatus["RECURRING_NEXT"] = "RECURRING_NEXT";
    /** Marks the most recent ended occurrence of the recurring event. */
    EventsRecurrenceStatusStatus["RECURRING_LAST_ENDED"] = "RECURRING_LAST_ENDED";
    /** Marks the most recent canceled occurrence of the recurring event. */
    EventsRecurrenceStatusStatus["RECURRING_LAST_CANCELED"] = "RECURRING_LAST_CANCELED";
})(EventsRecurrenceStatusStatus || (EventsRecurrenceStatusStatus = {}));
export var EventStatus;
(function (EventStatus) {
    /** Event is public and scheduled to start */
    EventStatus["SCHEDULED"] = "SCHEDULED";
    /** Event has started */
    EventStatus["STARTED"] = "STARTED";
    /** Event has ended */
    EventStatus["ENDED"] = "ENDED";
    /** Event was canceled */
    EventStatus["CANCELED"] = "CANCELED";
    /** Event is not public and needs to be published */
    EventStatus["DRAFT"] = "DRAFT";
})(EventStatus || (EventStatus = {}));
export var EventType;
(function (EventType) {
    /** Type not available for this request fieldset */
    EventType["NA_EVENT_TYPE"] = "NA_EVENT_TYPE";
    /** Registration via RSVP */
    EventType["RSVP"] = "RSVP";
    /** Registration via ticket purchase */
    EventType["TICKETS"] = "TICKETS";
    /** External registration */
    EventType["EXTERNAL"] = "EXTERNAL";
    /** Registration not available */
    EventType["NO_REGISTRATION"] = "NO_REGISTRATION";
})(EventType || (EventType = {}));
export var RegistrationStatus;
(function (RegistrationStatus) {
    /** Registration status is not applicable */
    RegistrationStatus["NA_REGISTRATION_STATUS"] = "NA_REGISTRATION_STATUS";
    /** Registration to event is closed */
    RegistrationStatus["CLOSED"] = "CLOSED";
    /** Registration to event is closed manually */
    RegistrationStatus["CLOSED_MANUALLY"] = "CLOSED_MANUALLY";
    /** Registration is open via RSVP */
    RegistrationStatus["OPEN_RSVP"] = "OPEN_RSVP";
    /** Registration to event waitlist is open via RSVP */
    RegistrationStatus["OPEN_RSVP_WAITLIST"] = "OPEN_RSVP_WAITLIST";
    /** Registration is open via ticket purchase */
    RegistrationStatus["OPEN_TICKETS"] = "OPEN_TICKETS";
    /** Registration is open via external URL */
    RegistrationStatus["OPEN_EXTERNAL"] = "OPEN_EXTERNAL";
    /** Registration will be open via RSVP */
    RegistrationStatus["SCHEDULED_RSVP"] = "SCHEDULED_RSVP";
})(RegistrationStatus || (RegistrationStatus = {}));
export var RsvpStatusOptions;
(function (RsvpStatusOptions) {
    /** Only YES RSVP status is available for RSVP registration */
    RsvpStatusOptions["YES_ONLY"] = "YES_ONLY";
    /** YES and NO RSVP status options are available for the registration */
    RsvpStatusOptions["YES_AND_NO"] = "YES_AND_NO";
})(RsvpStatusOptions || (RsvpStatusOptions = {}));
export var EventsTaxType;
(function (EventsTaxType) {
    /** Tax is included in the ticket price. */
    EventsTaxType["INCLUDED"] = "INCLUDED";
    /** Tax is added to the order at the checkout. */
    EventsTaxType["ADDED"] = "ADDED";
    /** Tax is added to the final total at the checkout. */
    EventsTaxType["ADDED_AT_CHECKOUT"] = "ADDED_AT_CHECKOUT";
})(EventsTaxType || (EventsTaxType = {}));
export var VisitorType;
(function (VisitorType) {
    /** Site visitor (including member) */
    VisitorType["VISITOR"] = "VISITOR";
    /** Site member */
    VisitorType["MEMBER"] = "MEMBER";
    /** Site visitor or member */
    VisitorType["VISITOR_OR_MEMBER"] = "VISITOR_OR_MEMBER";
})(VisitorType || (VisitorType = {}));
export var ConferenceType;
(function (ConferenceType) {
    /** Everyone in the meeting can publish and subscribe video and audio. */
    ConferenceType["MEETING"] = "MEETING";
    /** Guests can only subscribe to video and audio. */
    ConferenceType["WEBINAR"] = "WEBINAR";
})(ConferenceType || (ConferenceType = {}));
export var State;
(function (State) {
    /** Created manually by the user. */
    State["MANUAL"] = "MANUAL";
    /** Created automatically. */
    State["AUTO"] = "AUTO";
    /** Created when publishing recurring events. */
    State["RECURRING_EVENT"] = "RECURRING_EVENT";
    /** Category is hidden. */
    State["HIDDEN"] = "HIDDEN";
    /** Category is used to store component events. */
    State["COMPONENT"] = "COMPONENT";
})(State || (State = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map